import AdminTextInput from 'components/atoms/adminTextInput';
import LongRectangleTextButton from 'components/atoms/longRectangleTextButton';
import AdminPanelUI from 'components/molecules/adminPanelUI';
import {useAdminGeneralStore} from 'contexts/StoreContext';
import {useTheme} from 'contexts/ThemeContext';
import {observer} from 'mobx-react';
import {Screens} from 'navigations/Screens';
import React, {useEffect} from 'react';
import {View} from 'react-native';
import strings from 'translations';
import styleSheet from './styles';

const AdminPanelGeneral = observer(() => {
  const theme = useTheme();
  const styles = styleSheet(theme);

  const generalStore = useAdminGeneralStore();

  let schoolData = generalStore.getSchoolData();

  useEffect(() => {
    generalStore.fetchSchoolData();
  }, []);

  const handleSaveFields = async () => {
    await generalStore.updateSchoolData();
  };

  const LeftView = (
    <View style={styles.inputContainer}>
      <AdminTextInput
        title={strings.admin.schoolName}
        placeholder={strings.admin.schoolName}
        value={schoolData.name}
        isGeneral={true}
        onChangeText={newValue => {
          generalStore.setSchoolName(newValue);
        }}
      />
      <AdminTextInput
        title={strings.admin.schoolAddress}
        placeholder={strings.admin.schoolAddress}
        value={schoolData.address}
        isGeneral={true}
        onChangeText={newValue => {
          generalStore.setSchoolAddress(newValue);
        }}
      />
    </View>
  );

  const RightView = (
    <View style={styles.inputContainer}>
      <AdminTextInput
        title={strings.admin.directorName}
        placeholder={strings.admin.directorName}
        value={schoolData.directorName}
        isGeneral={true}
        onChangeText={newValue => {
          generalStore.setDirectorName(newValue);
        }}
      />
      <AdminTextInput
        title={strings.admin.directorEmail}
        placeholder={strings.admin.directorEmail}
        value={schoolData.directorEmail}
        isGeneral={true}
        onChangeText={newValue => {
          generalStore.setDirectorEmail(newValue);
        }}
      />
    </View>
  );

  return (
    <AdminPanelUI
      title={strings.admin.general}
      activeName={Screens.AdminPanelGeneralScreen.name}>
      <View>
        <View style={styles.inputView}>
          {LeftView}
          {RightView}
        </View>
        <LongRectangleTextButton
          onPress={() => handleSaveFields()}
          title={strings.profile.save}
          titleColor={styles.saveButtonTextColor}
          buttonStyle={styles.saveButtonStyle}
        />
      </View>
    </AdminPanelUI>
  );
});

export default AdminPanelGeneral;
